import { useState } from 'react';

export const useDeposite = () => {
  const [showDeposit, setShowDeposit] = useState(false);

  const onChangeShowDeposite = (v: boolean) => {
    setShowDeposit(v);
  };

  return {
    showDeposit,
    onChangeShowDeposite,
  };
};
